namespace Newtonsoft.ViewModels.Account {
    export class LoginViewModel {
        emailAddress = ko.observable<string>().extend({
            required: {
                params: true,
                message: "Your email address is required"
            }
        });
        password = ko.observable<string>().extend({
            required: {
                params: true,
                message: "Password is required"
            }
        });
        rememberMe = ko.observable<boolean>();
        validation: any;
        tokenHeader = ko.observable<string>();

        constructor(tokenHeader) {
            this.tokenHeader(tokenHeader);
            this.validation = ko.validatedObservable(this);
        }

        async login() {
            if (!this.validation.isValid()) {
                this.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                emailAddress: this.emailAddress(),
                password: this.password(),
                rememberMe: this.rememberMe()
            });

            Newtonsoft.showLoading("body");

            const response = await fetch("/api/account/login", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.tokenHeader()
                },
                body: json
            });

            if (response.ok) {
                var returnTo = Newtonsoft.getParameterByName("return_to");
                if (!returnTo) {
                    window.location.href = "/account";
                } else {
                    window.location.href = "/account/supportdesk?return_to=" + returnTo;
                }
            } else {
                await Newtonsoft.handleFailure(this, response);
                Newtonsoft.hideLoading("body");
            }
        }
    }
}
